export default __webpack_public_path__ + "static/thumb-landscape-e5ec1853b8a04eea2e3adcebbce0c47c.png";